import React from 'react';
import { BrowserRouter, Route, Routes } from 'react-router-dom';
import { NavigationHandler } from '@epcbuilder/lib/components/Layout';
import { UrlParamsToCookies } from '@epcbuilder/lib/components/UrlParamsToCookie';
import FAQ from '@/app/faq';
import FinanaceFunding from '@/app/financefunding';
import HomeImprovementsPage from '@/app/homeimprovementspage';
import InstallMeasures from '@/app/installmeasures';
import LandingPage from '@/app/landing';
import Privacy from '@/app/privacy';
import QualityAssurance from '@/app/qualityassurance';
import QuickWins from '@/app/quickwins';
import Terms from '@/app/terms';
import WhatToExpect from '@/app/whattoexpect';
import NotFound from './app/404';
import CavityWallInsulation from './app/cavitywallinsulation';
import Complaints from './app/complainsprocedure';
import ContactUs from './app/contactus';
import DirectDebitGuarantee from './app/directdebitguarantee';
import InternalWallInsulation from './app/internalwallinsulation';
import LoftInsulation from './app/loftinsulation';
import Refund from './app/refund';
import RoofInsulation from './app/roofinsulation';
import SolarPvSystem from './app/solarpvsystem';
import WhoWeAre from './app/whoweare';
import YourSavings from './app/yoursavings';

const AppRoutes = () => {
  return (
    <BrowserRouter>
      <UrlParamsToCookies>
        <NavigationHandler>
          <Routes>
            <Route path="/">
              <Route index element={<LandingPage />} />
              <Route path="faq" element={<FAQ />} />
              <Route path="privacy" element={<Privacy />} />
              <Route path="terms" element={<Terms />} />
              <Route path="refund" element={<Refund />} />
              <Route path="direct-debit-guarantee" element={<DirectDebitGuarantee />} />
              <Route path="what-to-expect" element={<WhatToExpect />} />
              <Route path="quick-wins" element={<QuickWins />} />
              <Route path="install-measures" element={<InstallMeasures />} />
              <Route path="home-improvements" element={<HomeImprovementsPage />} />
              <Route path="quality-assurance" element={<QualityAssurance />} />
              <Route path="finance-and-funding" element={<FinanaceFunding />} />
              <Route path="your-savings" element={<YourSavings />} />
              <Route path="contactus" element={<ContactUs />} />
              <Route path="complaints" element={<Complaints />} />
              <Route path="who-we-are" element={<WhoWeAre />} />
              <Route path="loft-insulation" element={<LoftInsulation />} />
              <Route path="cavity-wall-insulation" element={<CavityWallInsulation />} />
              <Route path="solar-pv-system" element={<SolarPvSystem />} />
              <Route path="roof-insulation" element={<RoofInsulation />} />
              <Route path="internal-wall-insulation" element={<InternalWallInsulation />} />
              <Route path="*" element={<NotFound />} />
            </Route>
          </Routes>
        </NavigationHandler>
      </UrlParamsToCookies>
    </BrowserRouter>
  );
};

export default AppRoutes;
